import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Subscription } from 'rxjs';
import { IInlineAction, IRightClickCellData, ITableEvent } from 'src/app/shared/interfaces/ITable';
import { TableService } from 'src/app/services/table.service';
import { TableEvent, TableLayout } from 'src/app/shared/enums';

@Component({
  selector: 'app-inline-action',
  standalone: true,
  templateUrl: './inline-action.component.html',
  styleUrls: ['./inline-action.component.scss'],
  imports: [MatMenuModule, MatButtonModule, TablerIconsModule, TranslateModule, CommonModule, MatTooltipModule]
})
export class InlineActionComponent implements OnDestroy {
  @Input() inlineActions?: IInlineAction[] = [];
  @Input() dropdownIcon?: string;
  @Input() rightClickShowDropdown?: boolean = true; // right click row to show dropdown ?
  @Input() row?: any;
  @Input() style?: any;
  @Input() class?: string;
  @Input() layout: TableLayout = TableLayout.CLASSIC;
  unsubscribe: Subscription[] = [];
  // Is called by code ?, not by user
  // when click cell, not click inline action button
  programmaticClick = false;

  constructor(private tableService: TableService) {
    const unsubscribe = this.tableService.tabObservable.subscribe(({ eventType, eventData }: ITableEvent) => {
      eventType === TableEvent.RIGHT_CLICK_CELL && eventData.cell.row === this.row && this.dropdownIcon && this.showDropdown(eventData);
    });
    this.unsubscribe.push(unsubscribe);
  }

  get InlineActionsCount(): number {
    return this.inlineActions?.filter((action) => !action.hidden?.()).length ?? 0;
  }

  get isModernLayout(): boolean {
    return this.layout === TableLayout.MODERN;
  }

  // show inline action dropdown when right click on any cell
  showDropdown({ event }: IRightClickCellData) {
    const parent = event.target.closest('tr');
    const btnMenu = parent?.querySelector('#dropdown-btn');
    this.programmaticClick = true;
    // run before menuOpened and onClickDropdownButton
    btnMenu?.click();
    setTimeout(() => {
      this.programmaticClick = false;
      const menuContent = document.querySelector<HTMLElement>('.cdk-overlay-pane');
      // reposition
      // move dropdown to mouse position
      if (menuContent) {
        menuContent.style.top = event.clientY + 'px';
        menuContent.style.left = event.clientX + 'px';
        menuContent.style.position = 'fixed';
        menuContent.style.display = 'block';
      }
    }, 0);
  }

  // called when click button
  // or button.click();
  onClickDropdownButton(event: any) {
    event.stopPropagation(); // block event from row click
    if (!this.programmaticClick) {
      const menuContent = document.querySelector<HTMLElement>('.cdk-overlay-pane');
      if (menuContent) {
        menuContent.style.display = 'block';
      }
    }
  }

  // called when open menu (before open animation)
  // run before onClickDropdownButton
  menuOpened() {
    const menuContent = document.querySelector<HTMLElement>('.cdk-overlay-pane');
    // hide menu when open
    // only show menu after reposition
    if (menuContent) {
      menuContent.style.display = 'none';
    }
  }

  getDisable(inlineAction: IInlineAction) {
    if (typeof inlineAction.disabled === 'function') {
      return inlineAction.disabled();
    }
    return inlineAction.disabled;
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
